export enum AMBIT_MESSAGE_CONTENT_TYPE {
  TEXT = 'text',
  CARD_HERO = 'application/vnd.microsoft.card.hero',
}

export interface Message {
  isUser: boolean;
  contentType: AMBIT_MESSAGE_CONTENT_TYPE;
  text?: string;
  attachments: {
    href?: string;
    imageUrl?: string;
    title?: string;
    text?: string;
  }[];
  isNewBlock?: boolean;
}

export interface Prompt {
  prompt: string;
  keywords: string[];
}
